import { useGetVideosQuery } from "@features/videos/videosApi";
import Video from "./Video";

const VideoList = () => {
  const { data: videos, isLoading, isError } = useGetVideosQuery();

  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div className="text-center">Loading...</div>;
  }

  if (!isLoading && isError) {
    content = (
      <div className="text-center text-red-500">Internal server error!</div>
    );
  }

  if (!isLoading && !isError && videos?.length === 0) {
    content = <div className="text-center">No videos found!</div>;
  }

  if (!isLoading && !isError && videos?.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Video Title</th>
            <th className="table-th">Description</th>
            <th className="table-th">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-600/50">
          {videos.map((video) => (
            <Video key={video.id} video={video} />
          ))}
        </tbody>
      </table>
    );
  }

  return <div className="overflow-x-auto mt-4">{content}</div>;
};

export default VideoList;
